/**
 * Longest `from`..`to` span the reporting queries may materialise (two years plus a leap
 * day). Without it a request such as `from=0001-01-01` builds a CTE spanning millennia.
 */
export const MAX_REPORT_SPAN_DAYS = 731;
